import makeStyles from '@mui/styles/makeStyles';
import React, { useEffect, useState } from 'react';
import { ISlideObservable, Slide, SlideEvent } from './Slide';

const useStyles = makeStyles((_theme) => ({
  slide: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
  animateInStarted: {},
  animatedIn: {},
  animateOutStarted: {},
  animatedOut: {
    display: 'none',
  },
}));

export interface ISlideContainerProps {
  children: any;
  slideObservable: ISlideObservable;
}

export default function SlideContainer({
  children,
  slideObservable,
}: ISlideContainerProps) {
  const classes = useStyles();

  const [lastEvent, setLastEvent] = useState<SlideEvent>();

  useEffect(() => {
    const observer = (_slide: Slide, event: SlideEvent) => {
      setLastEvent(event);
    };

    slideObservable.observe(observer);

    return () => {
      slideObservable.unobserve(observer);
    };
  }, [slideObservable]);

  const getSlideClassName = () => {
    switch (lastEvent) {
      case SlideEvent.animateInStarted:
        return classes.animateInStarted;
      case SlideEvent.animatedIn:
        return classes.animatedIn;
      case SlideEvent.animateOutStarted:
        return classes.animateOutStarted;
      case SlideEvent.animatedOut:
        return classes.animatedOut;
      default:
        return classes.animatedOut;
    }
  };

  return (
    <div className={`${classes.slide} ${getSlideClassName()}`}>{children}</div>
  );
}
